import UyumDynaList from './UyumDynaList';
import AudioManage from './AudioManage';
import VoiceRecorder from './VoiceRecorder';


function ExtraEntry() {
   return <h1>Extra Entry Page</h1>; 
  //  return <AudioManage />; 
  //  return <VoiceRecorder />; 
} /* End of ExtraEntry */


export default ExtraEntry;